const PAYMENT_SUCCESS_SESSION_STORAGE_KEY = 'lipPaymentSuccessSessionId'
export const PAYMENT_SUCCESS_LOCAL_STORAGE_KEY = 'lipPaymentReturnPending'
const PAYMENT_RETURN_PENDING_TTL_MS = 24 * 60 * 60 * 1000

export function normalizeQueryValue(value) {
  if (Array.isArray(value)) return value[0]
  return value
}

export function readPaymentSuccessSessionIdFromSearch(search) {
  const params = new URLSearchParams(search || '')
  const status = (params.get('status') || '').toLowerCase()
  const sessionId = params.get('sessionId') || params.get('session_id')
  if (status !== 'success' || !sessionId) return null
  return String(sessionId)
}

export function persistPaymentReturnPending(sessionId, selection = null) {
  if (!import.meta.client || !sessionId) return
  try {
    localStorage.setItem(
      PAYMENT_SUCCESS_LOCAL_STORAGE_KEY,
      JSON.stringify({
        sessionId: String(sessionId),
        at: Date.now(),
        ...(selection ? { selection } : {}),
      }),
    )
  } catch {
    /* ignore */
  }
}

export function readPaymentReturnPending() {
  if (!import.meta.client) return null
  try {
    const raw = localStorage.getItem(PAYMENT_SUCCESS_LOCAL_STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    const age = Date.now() - Number(data?.at || 0)
    if (!data?.sessionId || age > PAYMENT_RETURN_PENDING_TTL_MS) {
      localStorage.removeItem(PAYMENT_SUCCESS_LOCAL_STORAGE_KEY)
      return null
    }
    return data
  } catch {
    return null
  }
}

export function hasPaymentReturnPending() {
  return !!readPaymentReturnPending()
}

export function clearPaymentReturnPending() {
  if (!import.meta.client) return
  try {
    localStorage.removeItem(PAYMENT_SUCCESS_LOCAL_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

export function isPaymentReturnPending(route, landingSearch = '') {
  if (readPaymentSuccessSessionId(route, landingSearch)) return true
  if (!import.meta.client) return false
  try {
    if (sessionStorage.getItem(PAYMENT_SUCCESS_SESSION_STORAGE_KEY)) return true
  } catch {
    /* ignore */
  }
  return hasPaymentReturnPending()
}

export function readPaymentSuccessSessionId(route, landingSearch = '') {
  const fromLanding = readPaymentSuccessSessionIdFromSearch(landingSearch)
  if (fromLanding) return fromLanding

  if (import.meta.client) {
    const fromWindow = readPaymentSuccessSessionIdFromSearch(window.location.search)
    if (fromWindow) return fromWindow
  }

  const status = String(route.query.status ?? '').toLowerCase()
  const sessionId = normalizeQueryValue(route.query.sessionId || route.query.session_id)
  if (status !== 'success' || !sessionId) return null
  return String(sessionId)
}

export function stripPaymentQueryFromRoute(route, router) {
  const nextQuery = { ...route.query }
  delete nextQuery.status
  delete nextQuery.sessionId
  delete nextQuery.session_id
  delete nextQuery.product_id
  router.replace({ path: route.path, query: nextQuery, hash: route.hash })
}

export function resolveAuthToken(userStore) {
  const token = userStore.token || localStorage.getItem('token')
  if (token && !userStore.token) {
    userStore.setToken(token)
  }
  return token
}

export { PAYMENT_SUCCESS_SESSION_STORAGE_KEY }
